import React from 'react';
import { Typography } from '@mui/material';
import GridContainer from 'components/shared/GridContainer';
import GridItem from 'components/shared/GridItem';
import Card from 'components/shared/Card';
import { IPCheckSession } from 'store/types/Meeting';
import { QuestionResponse } from 'store/enums/BallotReviewTypes';

interface TrademarkViewCardProps {
  ipCheckSession: IPCheckSession;
}

const TrademarkViewCard: React.FunctionComponent<TrademarkViewCardProps> = ({ ipCheckSession }) => {
  const trademarkResult =
    ipCheckSession.hasTrademark === QuestionResponse.No
      ? 'Go to IP check completion condition check'
      : ipCheckSession.isTrademarkJustified === QuestionResponse.Yes
      ? 'Go to IP check completion condition check'
      : ipCheckSession.isTrademarkJustified === QuestionResponse.No
      ? 'The Document is failed and returned to the TF'
      : undefined;

  return (
    <GridContainer>
      <GridItem>
        <Card title={<Typography variant="h6">Trademark</Typography>} bordered>
          <GridContainer spacing={1}>
            <GridItem md={12}>
              <Typography>
                <strong>Assessment of disclosed (identified) trademark</strong>
              </Typography>
            </GridItem>
            <GridItem md={12}>
              <Typography>
                <strong>Is there any trademark in the Standard/Safety Guideline?: </strong>
                {ipCheckSession.hasTrademark ?? ''}
              </Typography>
            </GridItem>

            {ipCheckSession.hasTrademark === QuestionResponse.Yes && (
              <GridItem md={12}>
                <Typography>
                  <strong>Is every instance of trademark use technically justified?: </strong>
                  {ipCheckSession.isTrademarkJustified ?? ''}
                </Typography>
              </GridItem>
            )}
            {trademarkResult && (
              <GridItem md={12}>
                <Typography>
                  <strong>Result:</strong> {trademarkResult}
                </Typography>
              </GridItem>
            )}
          </GridContainer>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default TrademarkViewCard;
